// Shows the sticky product bar (see product-bar.php) once the element it
// watches - data-son-bar-watch, by default the product hero - has scrolled
// out above the viewport, hides it again when scrolling back up, and also
// while the footer is in view so the bar never floats over it. On a bundle
// page it steps aside for the item list too: that list carries its own Try
// buttons, so the bar would only sit on top of what it duplicates.

function bindProductBar(bar) {
    if (bar.dataset.sonBarReady) {
        return;
    }
    bar.dataset.sonBarReady = 'true';

    const sentinel = document.querySelector(bar.dataset.sonBarWatch || '.son-product-highlight-box--hero');
    if (!sentinel) {
        return;
    }

    const footer = document.querySelector('[data-elementor-type="footer"]');
    const list = document.querySelector('.son-bundle-products');
    let heroPassed = false;
    let footerInView = false;
    let listInView = false;

    const sync = () => bar.classList.toggle('is-visible', heroPassed && !footerInView && !listInView);

    new IntersectionObserver((entries) => {
        const entry = entries[entries.length - 1];
        heroPassed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        sync();
    }).observe(sentinel);

    if (footer) {
        new IntersectionObserver((entries) => {
            footerInView = entries[entries.length - 1].isIntersecting;
            sync();
        }).observe(footer);
    }

    if (list) {
        new IntersectionObserver((entries) => {
            listInView = entries[entries.length - 1].isIntersecting;
            sync();
        }).observe(list);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.son-product-bar').forEach(bindProductBar);
});
